import React, { useState, useEffect } from 'react';
import '../styles.css'
import './Agenda.css'
import Titulo from '../../components/Título/Titulo';

function Agenda({backgroundImage}) {

  const [tabSch , setTabSch] = useState(null);
  const [loading, setLoading] = useState(true); 

  useEffect(() => {

    const fetchAgenda = async() => {

      const spreadsheetID =  process.env.REACT_APP_SCHEDULE_SPREADSHEET_ID
      const urlSch = `https://docs.google.com/spreadsheets/d/${spreadsheetID}/gviz/tq?tqx=out:json&tq=select%20*&headers=1`
      
      try {

        const res = await fetch(urlSch);
        const text = await res.text();
        const response = JSON.parse(text.slice(47, -2));
        
        setTabSch(response.table.rows)
      } catch (error) {
        console.error('Erro ao buscar dados:', error);
      } finally {
        setLoading(false); 
      }

    };
    
    fetchAgenda();
  }, []);

  const titleArr = ["Data", "Evento" , "Local" , "Detalhes", ""]
  
  return ( 
      <div className='agenda-content'>
        <Titulo title='Agenda' backgroundImage={backgroundImage} position= 'right 25%'/>

        {loading ? <p>Carregando dados...</p> : 
          tabSch?.length ? 
            <div className='table-div'>
              <table>
                <thead>
                  <tr>
                    {titleArr.map((title, idx) => (
                      <th key={idx}><h2>{title}</h2></th>
                    ))}
                  </tr>
                </thead>
                <tbody >
                  {
                    tabSch.map( (row, idx) => {
      
                      let rowArray = row.c.slice(0,5)    
                      let button = createButton(rowArray[4] && rowArray[4].v)
                      rowArray = rowArray.slice(0,4)
      
                      return (
                        <React.Fragment key={idx}>
                          <tr>
                            {rowArray.map((el,idx) => {
                                if(idx === 0 && el && el.v) {
                                  return <td key={idx}>{dateFormat(el.v)}</td>
                                }
                              
                                return (
                                  <td key={idx}>
                                    {el && el.v}
                                  </td>)
                              })
                            }
    
                            <td>
                              {button}
                            </td>
                          </tr>
                          <tr >
                            <td colSpan={5}>                            
                              <div className='stars'/>
                            </td>
                          </tr>
                        </React.Fragment>
                      )}
                  )}
                  </tbody>
                </table>
              </div> : 
              <div className='table-div'><h1> Atualizações em breve! Nos acompanhe também pelo instagram: <a href='https://www.instagram.com/maracajudegaveta/' target='_blank' rel="noreferrer"> @maracajudegaveta</a></h1></div>
        }
      </div>)
}

export default Agenda



function createButton(link) {

  if(!link) return null;
  return (
        <button  onClick={() => window.open('https://'+ link.toString(), '_blank')}>
          <div style={{fontSize: 'clamp(20px, 2vw, 30px)'}}>          
            Comprar ingressos
          </div>
        </button>
  ) 
}

function dateFormat(date) {

  const regex = /Date\((\d+),(\d+),(\d+)\)/;
  const result = (date && date.match(regex)) || null;

  if (result) {
      const ano = parseInt(result[1], 10);  
      const mes = parseInt(result[2], 10);  
      const dia = parseInt(result[3], 10);  

      const date = new Date(ano, mes, dia);

      const formatedDate = date.toLocaleDateString('pt-BR');
      return formatedDate || ''
    }
}